module.exports = __webpack_public_path__ + "static/media/measurements-bot.a485168c.png";